import { FormattedMessage } from "react-intl";
import { Location, Navigate } from "react-router";
import ChangePasswordPage from "../modules/auth/page/ChangePasswordPage";
import { AppState } from "../redux/reducer";
import {
  AdministrativeIcon,
  BookIcon,
  CalendarIcon,
  CensorshipIcon,
  ConstructionIcon,
  CubeIcon,
  Dashboard,
  MiningData,
  MonitorOnline,
  Report,
  Setting,
  UserIcon,
  VideoIcon,
} from "../svg";
import { ROUTES } from "./constants";
import { IRouteObject } from "./utils";
import MonitoringUnifiedPage from "../modules/monitoringLed/page/MonitoringUnifiedPage";

export const ADMIN_ROUTES = (
  appState: AppState,
  location: Location
): IRouteObject[] => [
  {
    path: "*",
    element: <MonitoringUnifiedPage/>,
  },
];
